import APIService from '../../services/api';
import { setError } from '../error/actions';
import { logoutUser } from '../connection/actions';

export const SET_VARIABLE_ID_TO_DISPLAY = 'SET_VARIABLE_ID_TO_DISPLAY';
export const SET_REPORT_ID_TO_DISPLAY = 'SET_REPORT_ID_TO_DISPLAY';
export const LOAD_SYSTEMS = 'LOAD_SYSTEMS';
export const RECEIVED_DATA = 'RECEIVED_DATA';
export const NO_DATA = 'NO_DATA';
export const LOADING = 'LOADING';
export const LOADING_COMMENT = 'LOADING_COMMENT';

export const loadBulletin = () => ({
  type: LOAD_SYSTEMS,
});

export const receivedData = data => ({
  type: RECEIVED_DATA,
  data,
});

export const noData = data => ({
  type: NO_DATA,
  data,
});

export const loading = () => ({
  type: LOADING,
});

export const loadingComment = () => ({
  type: LOADING_COMMENT,
});

const handleTokenRefreshFail = (err, dispatch) => {
  if (
    err?.message.includes('Unable to refresh token') ||
    err?.message.includes('Please login again')
  ) {
    dispatch(logoutUser());
  }
};

const postError = 'Issue while sending data to the server: ';

export const setMapsAsSeen = mapIds => dispatch =>
  APIService.patchMapsAsSeen(mapIds).catch(err => {
    handleTokenRefreshFail(err, dispatch);
    dispatch(setError(`${postError}${err}`));
  });
